import z from 'zod';

/**
 * Callable `tradeTagGetForUser` returns rows shaped like this (aligned with `tradeTagSchema` fields used on the wire).
 */
export const tradeTagCallableRowSchema = z.object({
  id: z.string(),
  label: z.string().min(1),
  description: z.string().optional(),
});

export interface TradeTagCallableRow extends z.infer<typeof tradeTagCallableRowSchema> {}
export const tradeTagsCallableResultSchema = z.array(tradeTagCallableRowSchema);
